import React from "react";
import { ResourceAvatar } from "@common/resourceAvatar";
import { Props } from "./types";
import styles from "./styles.scss";

function Resource({ resource }: Props) {
  return (
    <div className={styles.resource}>
      <div className={styles.avatar}>
        <ResourceAvatar resource={resource} />
      </div>
      <div className={styles.card}>
        <h3 className={styles.name}>{resource.name}</h3>
        {!!resource.profession && (
          <p className={styles.profession}>{resource.profession}</p>
        )}
      </div>
    </div>
  );
}

export { Resource };
